import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios  from 'axios'
import {Toast,Indicator,MessageBox,DatetimePicker,Popup} from 'mint-ui'
import 'mint-ui/lib/style.css';

axios.defaults.baseURL='http://82.157.32.109:8188'

Vue.prototype.$axios = axios
Vue.prototype.$Toast = Toast
Vue.prototype.$Loading = Indicator
Vue.prototype.$MessageBox = MessageBox
Vue.component(DatetimePicker.name, DatetimePicker);
Vue.component(Popup.name, Popup);

Vue.config.productionTip = false
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')